// extracted by mini-css-extract-plugin
export default {"input-range":"InputSlider_input-range__UT1Q0"};